<template>
    <form class="form-horizontal" v-if="config">

        <div class="form-group">
            <label for="ignicao" class="col-sm-2 control-label">IGNIÇÃO:</label>
            <div class="col-sm-3">
                <select v-model.number="config.ignicao" class="form-control" id="ignicao">
                    <option :value="0">Não usar ignição</option>
                    <option :value="1">Ignição usado em linha</option>
                    <option :value="2">Ignição virtual (POWER)</option>
                    <option :value="3">Ignição virtual (MOTION)</option>
                </select>
            </div>
            <label for="tempo_2_sleep" class="col-sm-2 control-label">TEMPO PARA DORMIR (seg):</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.tempo_2_sleep" class="form-control input-sm" id="tempo_2_sleep">
            </div>
            <label for="tempo_2_ativar" class="col-sm-2 control-label">TEMPO PARA ATIVAR (seg):</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.tempo_2_ativar"  class="form-control" id="tempo_2_ativar" >
            </div>
        </div>

        <div class="form-group">
            <label for="tipo_input1" class="col-sm-2 control-label">TIPO ENTRADA 1:</label>
            <div class="col-sm-3">
                <select v-model.number="config.tipo_input1" class="form-control" id="tipo_input1">
                    <option :value="0">Borda de descida</option>
                    <option :value="1">Borda de subida</option>
                    <option :value="2">Borda de subida e descida</option>
                    <option :value="3">Botão de pânico</option>
                    <option :value="4">Botão de chamada 1</option>
                    <option :value="5">Botão de chamada 2</option>
                    <option :value="7">Anti-Furto</option>
                    <option :value="9">RESERVADO</option>
                    <option :value="11">Sensor de Porta</option>
                    <option :value="12">Ignição</option>
                    <option :value="13">Bloqueio ativado pelo jammer</option>
                    <option :value="15">Antifurto 2</option>
                    <option :value="17">Horimetro</option>
                    <option :value="19">Sensor de Chuva (Aterrado)</option>
                    <option :value="20">Sensor de Chuva (Aberto)</option>
                    <option :value="21">Sensor de Chuva (Pulsante)</option>
                </select>
            </div>
            <label for="tempo_leitura_input1" class="col-sm-2 control-label">TEMPO LEITURA IN. 1:</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.tempo_leitura_input1" class="form-control input-sm" id="tempo_leitura_input1">
            </div>
            <label for="taxa_transmissao" class="col-sm-2 control-label">TAXA DE TRANSMISSÃO:</label>
            <div class="col-sm-2">
                <select v-model.number="config.taxa_transmissao" class="form-control" id="taxa_transmissao">
                    <option :value="0">Desabilitado</option>
                    <option :value="1">4800 Bps</option>
                    <option :value="2">9600 Bps</option>
                    <option :value="3">19200 Bps</option>
                    <option :value="4">38400 Bps</option>
                    <option :value="5">11520 Bps</option>
                    <option :value="6">2400 Bps</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="tipo_input2" class="col-sm-2 control-label">TIPO ENTRADA 2:</label>
            <div class="col-sm-3">
                <select v-model.number="config.tipo_input2" class="form-control" id="tipo_input2">
                    <option :value="0">Borda de descida</option>
                    <option :value="1">Borda de subida</option>
                    <option :value="2">Borda de subida e descida</option>
                    <option :value="3">Botão de pânico</option>
                    <option :value="4">Botão de chamada 1</option>
                    <option :value="5">Botão de chamada 2</option>
                    <option :value="7">Anti-Furto</option>
                    <option :value="9">RESERVADO</option>
                    <option :value="11">Sensor de Porta</option>
                    <option :value="12">Ignição</option>
                    <option :value="13">Bloqueio ativado pelo jammer</option>
                    <option :value="15">Antifurto 2</option>
                    <option :value="17">Horimetro</option>
                    <option :value="19">Sensor de Chuva (Aterrado)</option>
                    <option :value="20">Sensor de Chuva (Aberto)</option>
                    <option :value="21">Sensor de Chuva (Pulsante)</option>
                </select>
            </div>
            <label for="tempo_leitura_input2" class="col-sm-2 control-label">TEMPO LEITURA IN. 2:</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.tempo_leitura_input2" class="form-control input-sm" id="tempo_leitura_input2">
            </div>
        </div>

        <div class="form-group">
            <label for="tipo_input3" class="col-sm-2 control-label">TIPO ENTRADA 3:</label>
            <div class="col-sm-3">
                <select v-model.number="config.tipo_input3" class="form-control" id="tipo_input3">
                    <option :value="0">Borda de descida</option>
                    <option :value="1">Borda de subida</option>
                    <option :value="2">Borda de subida e descida</option>
                    <option :value="3">Botão de pânico</option>
                    <option :value="4">Botão de chamada 1</option>
                    <option :value="5">Botão de chamada 2</option>
                    <option :value="7">Anti-Furto</option>
                    <option :value="9">RESERVADO</option>
                    <option :value="11">Sensor de Porta</option>
                    <option :value="12">Ignição</option>
                    <option :value="13">Bloqueio ativado pelo jammer</option>
                    <option :value="15">Antifurto 2</option>
                    <option :value="17">Horimetro</option>
                    <option :value="19">Sensor de Chuva (Aterrado)</option>
                    <option :value="20">Sensor de Chuva (Aberto)</option>
                    <option :value="21">Sensor de Chuva (Pulsante)</option>
                </select>
            </div>
            <label for="tempo_leitura_input3" class="col-sm-2 control-label">TEMPO LEITURA IN. 3:</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.tempo_leitura_input3" class="form-control input-sm" id="tempo_leitura_input3">
            </div>
        </div>

        <div class="form-group">
            <label for="tipo_output1" class="col-sm-2 control-label">TIPO OUTPUT 1:</label>
            <div class="col-sm-3">
                <select v-model.number="config.tipo_output1" class="form-control" id="tipo_output1">
                    <option :value="0">Entrada e saída geral</option>
                    <option :value="1">Imobilizador</option>
                    <option :value="2">Imobilizador Automático</option>
                    <option :value="3">Pulso</option>
                    <option :value="5">Buzina</option>
                    <option :value="8">Imobilizador2</option>
                    <option :value="9">Imobilizador2 Automático</option>
                </select>
            </div>
            <label for="active_output1" class="col-sm-2 control-label">ATIVAÇÃO OUTPUT 1:</label>
            <div class="col-sm-2">
                <select v-model.number="config.active_output1" class="form-control" id="active_output1">
                    <option :value="0">0 - Aterrada Direto</option>
                    <option :value="1">1 - Sem Aterramento</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="tipo_output2" class="col-sm-2 control-label">TIPO OUTPUT 2:</label>
            <div class="col-sm-3">
                <select v-model.number="config.tipo_output2" class="form-control" id="tipo_output2">
                    <option :value="0">Entrada e saída geral</option>
                    <option :value="1">Imobilizador</option>
                    <option :value="2">Imobilizador Automático</option>
                    <option :value="3">Pulso</option>
                    <option :value="5">Buzina</option>
                    <option :value="8">Imobilizador2</option>
                    <option :value="9">Imobilizador2 Automático</option>
                </select>
            </div>
            <label for="active_outpu2" class="col-sm-2 control-label">ATIVAÇÃO OUTPUT 2:</label>
            <div class="col-sm-2">
                <select v-model.number="config.active_outpu2" class="form-control" id="active_outpu2">
                    <option :value="0">0 - Aterrada Direto</option>
                    <option :value="1">1 - Sem Aterramento</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>

    </form>
</template>

<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "Eventos",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendEventos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
